/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from './api';

/** Get current agentic health monitor settings + last run summary. */
export const getAgenticStatus = async () => (await api.get('/agentic/status')).data;

/** Opt-in with consent. */
export const enableAgentic = async (payload = {}) =>
  (await api.post('/agentic/enable', payload)).data;

/** Opt-out. */
export const disableAgentic = async () => (await api.post('/agentic/disable')).data;

/** Trigger the monitor for the current user (demo/debug). */
export const runMonitorNow = async () => (await api.post('/agentic/run/me')).data;

/** List alerts, optionally filtered by status. */
export const listAgenticAlerts = async (statusFilter) => {
  const params = statusFilter ? { status_filter: statusFilter } : {};
  return (await api.get('/agentic/alerts', { params })).data;
};

/** Mark alert as acknowledged. */
export const acknowledgeAlert = async (alertId) =>
  (await api.post(`/agentic/alerts/${alertId}/acknowledge`)).data;

/** Dismiss an alert. */
export const dismissAlert = async (alertId, reason) =>
  (await api.post(`/agentic/alerts/${alertId}/dismiss`, { reason })).data;

/** Accept the priority booking suggestion — returns { redirect } to open the wizard. */
export const bookPrioritySlot = async (alertId) =>
  (await api.post(`/agentic/alerts/${alertId}/book-slot`)).data;
